import React from 'react';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import config from './config';
import Register from './pages/Register';
import Layout from '../../components/Layout';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <PersonAddIcon />,
    routes: [
      { name: 'Registro', path: `${path}/register`, component: Register },
    ],
  },
];

export default routes;
